import { DatePicker, Form } from "antd";
import { Rule } from "antd/es/form";
import dayjs from "dayjs";
import React from "react";

type Props = {
  index: number;
  styles: React.CSSProperties;
  rules: Rule[];
  label: string;
};

export default (props: Props) => {
  return (
    <Form.Item
      label={props.label}
      rules={props.rules}
      style={props.styles}
      valuePropName="value"
      getValueFromEvent={(date) => date?.toDate()}
      shouldUpdate={(prevValues, currentValues) => prevValues !== currentValues}
    >
      {({ getFieldValue, setFieldValue }) => {
        const currentValue = getFieldValue([
          "operations",
          props.index,
          "value",
        ]);
        const dateValue =
          currentValue instanceof Date ? dayjs(currentValue) : null;

        return (
          <DatePicker
            value={dateValue}
            onChange={(date) => {
              setFieldValue(
                ["operations", props.index, "value"],
                date?.toDate()
              );
            }}
          />
        );
      }}
    </Form.Item>
  );
};
